import React from 'react';
import { TextField } from 'react-admin';

const ActionField = ({ record, ...rest }) => {
  let color;

  switch (record.action) {
    case 'critical':
      color = '#f15b5b';
      break;
    case 'update':
      color = '#ecae3b';
      break;
    case 'valid':
      color = '#5ee25e';
      break;
    default:
      color = '';
      break;
  }

  return (
    <TextField
      style={{
        color: color,
        padding: '0.4em',
        textTransform: 'uppercase',
        fontWeight: 'bold'
      }}
      source="action"
      record={record}
      {...rest}
    />
  );
};

export default ActionField;
